function Card({ title, subtitle, avatarText, gradient, onClick }) {
  return (
    <div className="premium-card dark-card" onClick={onClick}>
      {/* Glow Layer */}
      <div className="card-glow"></div>

      {/* Avatar */}
      <div className="card-avatar dark-avatar" style={{ background: gradient }}>
        {avatarText}
      </div>

      {/* Title */}
      <h3 className="card-title-dark">{title}</h3>

      {/* Subtitle */}
      <p className="card-subtitle-dark">{subtitle}</p>

      {/* CTA */}
      <div className="card-link-dark">Explore →</div>
    </div>
  );
}

export default Card;
